module.exports = __webpack_public_path__ + "static/media/background.d4393508.png";